export default __webpack_public_path__ + "static/media/property_1_9.235820de.webp";